// 简历申请插件
import React from "react";
import organizationBrandNode from './config-organizationBrandNode';
import position from './config-position';
import WizTableForm from "../wizTableForm";

let organizationConfig = organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } });
let positionConfig = position(this, { apiParams: { state: 1 } });

const columns = () => {
  return [
    {
      name: 'id',
      dataIndex: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '姓名',
      name: 'searchFullName',
      dataIndex: 'searchFullName',
      searchItem: {}
    },
    {
      title: '账号',
      name: 'searchUserName',
      dataIndex: 'searchUserName',
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      dataIndex: 'fullName',
      tableItem: {
        width: 120
      }
    },
    {
      title: '账号',
      name: 'userName',
      dataIndex: 'userName',
      tableItem: {
        width: 120
      }
    },
    {
      title: '岗位',
      name: 'positionId',
      dataIndex: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio'
      }
    },
    {
      title: '经销商名称',
      name: 'dealerName',
      dataIndex: 'dealerName',
      searchItem: {}
    },
    {
      title: '组织编码',
      name: 'dealerCode',
      dataIndex: 'dealerCode',
      searchItem: {}
    },
    {
      title: '品牌',
      name: 'orgId',
      dataIndex: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio'
      }
    },
    {
      title: '岗位',
      name: 'positionName',
      dataIndex: 'positionName',
      tableItem: {
        width: 120
      }
    },
    {
      title: '经销商名称',
      tableItem: {
        width: 200,
        render: (text, record) => {
          let {dealerName, orgName} = record
          let value = orgName;
          if (dealerName!=null && dealerName!='' && dealerName!=undefined){
            value = dealerName;
          }
          return <span> { value } </span>
        }
      }
    },
    {
      title: '组织编码',
      name: 'orgCode',
      dataIndex: 'orgCode',
      tableItem: {
        width: 120
      }
    },
    {
      title: '品牌',
      name: 'brandName',
      dataIndex: 'brandName',
      tableItem: {
        width: 120
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'interviewResume/needAgainPageList',
    ...api
  }
}

const resumeApply = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    rowkey: 'id',
    rowName: 'fullName',
    cols: {
      xs: 24,
      md: 12,
      xl: 8
    },
    tableApi: tableApi(api)
  }
}

export default resumeApply
